import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { APP_ROUTES } from '@core/routes/app-routes';
import { AwsService, CommonService } from '__services';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private commonService: CommonService,
    private awsService: AwsService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {

    if (localStorage.getItem('access_token')) {
      this.preloadData();
      return true;
    }

    return this.awsService
      .currentUser()
      .then(async () => {
        this.preloadData();
        await this.commonService.getCompanyIdentifier();
        await this.commonService.checkCredentials();
        return true;
      })
      .catch(() => {
        const lang = state.root.queryParams['lang'];
        this.router.navigate([APP_ROUTES.LOGIN], { queryParams: { lang } });
        return false;
      });
  }

  preloadData(): void {
    if (!this.commonService.countries) {
      this.commonService.getCountries();
    }
    if (!this.commonService.personas) {
      this.commonService.getPersonas();
    }
  }
}
